/*
 * Copyright (c) Akveo 2019. All Rights Reserved.
 * Licensed under the Single Application / Multi Application License.
 * See LICENSE_SINGLE_APP / LICENSE_MULTI_APP in the 'docs' folder for license information on type of purchased license.
 */

import { Injectable } from '@angular/core';
import { Observable, of } from 'rxjs';
import { PurchaseDetailsApi } from '../api/purchasedetails.api';
import { switchMap, map } from 'rxjs/operators';
import { PurchaseDetailsData, PurchaseDetails } from '../../../interfaces/masters/purchasedetails';

@Injectable()
export class PurchaseDetailsService extends PurchaseDetailsData {

  constructor(private api: PurchaseDetailsApi) {
    super();
  }



  list(url: string): Observable<PurchaseDetails[]> {
    return this.api.list(url);
  }

  getById(url:string): Observable<PurchaseDetails>{
      return this.api.getById(url);
  }

  create(url: string, data:PurchaseDetails): Observable<PurchaseDetails> {
    return this.api.add(url,data);
  }

  update(url: string, data:PurchaseDetails): Observable<PurchaseDetails> {
    console.log('url', url);
    console.log('data', data);
    return this.api.update(url,data);
  }
 

  delete(url: string): Observable<boolean> {
    return this.api.delete(url);
  }
}
